export default __webpack_public_path__ + "static/media/province.bacfbc35.svg";